"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _material = require("@ori-ui/mui-bundle/material");
var _constants = require("../constants");
var _textInputData = require("../constants/textInputData");
const styleOverrides = {
  root: {
    [`&.OriSelectList .${_material.menuItemClasses.root}`]: {
      fontSize: _constants.textInputData.input.size,
      justifyContent: 'space-between',
      alignItems: 'flex-start',
      gap: 10,
      paddingRight: 12
    },
    [`&.OriSelectList .${_material.menuItemClasses.root}::after`]: {
      content: '""',
      flexShrink: 0,
      display: 'block',
      overflow: 'hidden',
      width: '24px',
      height: '24px',
      background: 'transparent'
    },
    [`&.OriSelectList .${_material.menuItemClasses.root}:focus`]: {
      backgroundColor: _constants.colors.primary.light
    },
    [`&.OriSelectList .${_material.menuItemClasses.root}:hover`]: {
      backgroundColor: _constants.colors.primary.light
    },
    [`&.OriSelectList .${_material.menuItemClasses.selected}:focus`]: {
      backgroundColor: 'transparent'
    },
    [`&.OriSelectList .${_material.menuItemClasses.selected}:hover`]: {
      backgroundColor: _constants.colors.primary.light
    },
    [`&.OriSelectList .${_material.menuItemClasses.selected}::after`]: {
      content: _textInputData.selectedMark
    }
  }
};
var _default = exports.default = {
  styleOverrides
};
//# sourceMappingURL=MuiList.js.map